import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMail, FiPhone, FiMapPin, FiInstagram, FiFacebook, FiTwitter, FiYoutube } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: FiInstagram, url: 'https://www.instagram.com/samsnutrihub/', label: 'Instagram' },
    { icon: FiFacebook, url: 'https://www.facebook.com/samsnutrihub/', label: 'Facebook' },
    { icon: FiTwitter, url: 'https://x.com/samsnutrihub', label: 'Twitter' },
    { icon: FiYoutube, url: 'https://www.youtube.com/@samsnutrihub', label: 'Youtube' }
  ];

  return (
    <footer className="bg-[#205C25] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About SNH */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4 font-poppins">About SNH</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Sam's Nutri Hub is dedicated to transforming lives through personalized nutrition and fitness plans. Led by experienced coaches Samruddhi, Nihal, and Sarthak, we embrace locally sourced foods and simple exercises to promote holistic well-being.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4 font-poppins">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors duration-200">About</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors duration-200">Contact</Link></li>
              <li><Link to="/results" className="text-gray-300 hover:text-white transition-colors duration-200">Results</Link></li>
              <li><Link to="/plans" className="text-gray-300 hover:text-white transition-colors duration-200">Plans</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4 font-poppins">Contact</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-2">
                <SafeIcon icon={FiMapPin} className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <div>
                  <p>Venkatesh Prime, 4th-floor</p>
                  <p>Burudgaon Road, Ahmednagar</p>
                  <p>Maharashtra, 414001</p>
                </div>
              </div>
              <a 
                href="tel:+919637375555" 
                className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors duration-200"
              >
                <SafeIcon icon={FiPhone} className="h-4 w-4 flex-shrink-0" />
                <span>+91 963 737 5555</span>
              </a>
              <a 
                href="mailto:hello@samsnutrihub.com" 
                className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors duration-200"
              >
                <SafeIcon icon={FiMail} className="h-4 w-4 flex-shrink-0" />
                <span>hello@samsnutrihub.com</span>
              </a>
            </div>
          </div>

          {/* Social Links */}
          <div className="col-span-1">
            <h3 className="text-lg font-semibold mb-4 font-poppins">Follow Us</h3>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                  aria-label={social.label}
                >
                  <SafeIcon icon={social.icon} className="h-6 w-6" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-600 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-300 text-sm">
              © {currentYear} Sam's Nutri Hub · All Rights Reserved
            </p>
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm">
              <Link to="/disclaimer" className="text-gray-300 hover:text-white transition-colors duration-200">Disclaimer</Link>
              <Link to="/privacy-policy" className="text-gray-300 hover:text-white transition-colors duration-200">Privacy Policy</Link>
              <Link to="/terms" className="text-gray-300 hover:text-white transition-colors duration-200">Terms</Link>
              <Link to="/refund-policy" className="text-gray-300 hover:text-white transition-colors duration-200">Refund Policy</Link>
              <Link to="/cookie-policy" className="text-gray-300 hover:text-white transition-colors duration-200">Cookie Policy</Link>
              <Link to="/affiliate-disclosure" className="text-gray-300 hover:text-white transition-colors duration-200">Affiliate Disclosure</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;